import snakeCase from 'snake-case'

/**
 * Converts object keys to snake_case
 *
 * @param {Record<string, any>} obj
 * @returns {Record<string, any>}
 */
export function toSnakeCase(obj: Record<string, any>): Record<string, any>
export function toSnakeCase(obj: undefined): undefined
export function toSnakeCase(obj: null): null
export function toSnakeCase(obj: number): number
export function toSnakeCase(obj: string): string
export function toSnakeCase(
  obj: Record<string, any> | undefined | null | string | number
): Record<string, any> | undefined | null | string | number {
  if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || !obj) {
    return obj
  }

  // converts each value to underscoredProps
  if (Array.isArray(obj)) {
    return obj.map(toSnakeCase) as Record<string, any>
  }

  // Underscore the keys and call for each value
  return Object.keys(obj).reduce((result, key) => {
    const underscoredKey = snakeCase(key)
    result[underscoredKey] = toSnakeCase(obj[key])
    return result
  }, {} as Record<string, any>)
}

export default toSnakeCase
